const apiRootUrl = process.env.NODE_ENV === 'test' ? 'http://localhost' : process.env.API_ROOT_URL
const apiAiFormRootUrl = process.env.NODE_ENV === 'test' ? 'http://localhost' : process.env.API_AI_FORM_ROOT_URL

export type ServiceKey = keyof typeof ServiceUrls

export const ServiceUrls = {
  AI_CHAT: `${apiRootUrl}/ai-chat`,
  AUDIT_LOG: `${apiRootUrl}/audit-log`,
  AUTH: `${apiRootUrl}/auth`,
  SLACK: `${apiRootUrl}/slack`,
  ACCOUNTING: `${apiRootUrl}/accounting`,
  EXTERNAL: `${apiRootUrl}/external`,
  EXTERNAL_OPERATION: `${apiRootUrl}/extops`,
  NOTIFICATIONS: `${apiRootUrl}/notifications`,
  INTEGRATIONS_V2: `${apiRootUrl}/integrations`,
  USERS: `${apiRootUrl}/users`,
  CORE: apiRootUrl,
  PUBLIC_MGMT: `${apiRootUrl}/public-mgmt`,
  ASSESSMENTS: `${apiRootUrl}/assessments`,
  AUCTIONS: `${apiRootUrl}/auctions`,
  NEXT_PUBLIC: process.env.NEXT_PUBLIC_BASE_PATH,
  // FILE_STORAGE is the external file storage service, documents is the internal hasura file store
  FILE_STORAGE: `${apiRootUrl}/file-storage`,
  DOCUMENTS: `${apiRootUrl}/documents`,
  EMAIL: `${apiRootUrl}/email`,
  RENEWALS: `${apiRootUrl}/renewals`,
  SCHEDULED_REQUESTS: `${apiRootUrl}/scheduled-requests`,
  CLM: `${apiRootUrl}/clm`,
  FORM_TEMPLATES: `${apiRootUrl}/form_templates`,
  INTAKES: `${apiRootUrl}/intakes`,
  RISKS: `${apiRootUrl}/risks`,
  REQUESTS: `${apiRootUrl}/requests`,
  CORE_DATA: `${apiRootUrl}/core-data`,
  COMMENTS: `${apiRootUrl}/comments`,
  CONFIG: `${apiRootUrl}/config`,
  CONFIG_SYNC: `${apiRootUrl}/config-sync`,
  PRODUCTS: `${apiRootUrl}/products`,
  CUSTOM_FIELDS: `${apiRootUrl}/custom-fields`,
  FIELDS: `${apiRootUrl}/fields`,
  BUDGET_APPROVALS: `${apiRootUrl}/budget-approvals`,
  BUDGETS: `${apiRootUrl}/budgets`,
  SUBPROCESSORS: `${apiRootUrl}/subprocessors`,
  ARTEFACTS: `${apiRootUrl}/artefacts`,
  SUPPLIERS: `${apiRootUrl}/suppliers`,
  LOGIN: `${apiRootUrl}/login`,
  RFX: `${apiRootUrl}/rfx`,
  HOSTED_CATALOGUES: `${apiRootUrl}/hosted-catalogues`,
  PUNCHOUT_CATALOGUES: `${apiRootUrl}/punchout-catalogues`,
  PURCHASE_ORDERS: `${apiRootUrl}/purchase-orders`,
  BILLS: `${apiRootUrl}/bills`,
  RECEIPTS: `${apiRootUrl}/receipts`,
  TASKS: `${apiRootUrl}/tasks`,
  AGENTS: `${apiRootUrl}/agents`,
  GLOBAL_AGENTS: `${apiRootUrl}/global-agents`,
  AGREEMENTS: `${apiRootUrl}/agreements`,
  REPORTING: `${apiRootUrl}/reporting`,
  OCR: `${apiRootUrl}/ocr`,
  ORGANISATIONS: `${apiRootUrl}/organisations`,
  TEAMS_APP: `${apiRootUrl}/ms-teams`,
  TPRM_CONTINUOUS_MONITORING: `${apiRootUrl}/tprm-continuous-monitoring`,
  SLACK_APP: `${apiRootUrl}/slack`,
  WORKOS: `${apiRootUrl}/workos`,
  ONESCHEMA: `${apiRootUrl}/oneschema`,
  ORG_SETTINGS: `${apiRootUrl}/org-settings`,
  PERMISSIONS: `${apiRootUrl}/permissions`,
  TAGS: `${apiRootUrl}/tags`,
  WORKFLOWS: `${apiRootUrl}/workflows`,
  EXPORT_JOBS: `${apiRootUrl}/export-jobs`,
  IMPORT_JOBS: `${apiRootUrl}/import-jobs`,
  VERIFICATION: `${apiRootUrl}/verification`,
  PRICE_INTELLIGENCE: `${apiRootUrl}/price-intelligence`,
  API_AI_FORM: apiAiFormRootUrl,
} as const
type EndpointId = string
export type ApiServiceDefinition = Record<EndpointId, { method: string; path: string }>
export type EndpointDefinition = { method: string; path: string }
